var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{staticClass:"mt-2",attrs:{"value":_vm.selectedOrganization},on:{"change":function($event){return _vm.$emit('change', $event)}}},_vm._l((_vm.organizationsForRadio),function(n,index){return _c('v-radio',{key:index,attrs:{"label":`${n.text} (${n.value})`,"value":n.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }